<template>
  <r-panel :disabled="disabled" :title="title" :button_add="true" @click_add="click_add">
    <r-treasure-piece-config-table ref="table" :items.sync="values" :toolbar="false"/>
  </r-panel>
</template>
<script>

import VueTypes from "vue-types";
import {TreasurePieceConfig} from "@/modules/redactor/models/smart-offer/bundle-treasure/TreasurePieceConfig";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RTreasurePieceConfigTable from "@/modules/redactor/views/smart-offer/bundle-treasure/r-treasure-piece-config-table.vue";

export default {
  name: "r-treasure-piece-config-panel",
  components: {RTreasurePieceConfigTable, RPanel},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Treasure Piece Config"),
    items: VueTypes.arrayOf(TreasurePieceConfig)
  },
  computed: {
    values() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>